 // const $ = require('jquery');
  import DateRangePicker from '../components/dateRange';
  import ProductDropDown from '../components/ProductDropDown';
  import ProductTypeDropDown from '../components/ProductTypeDropDown';
  import WithSystem from './../service/WithSystem';
  class FilterBlock extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        product_type : '',
        keyword : props.queryFilter.searchkey
      };
    }
   
    enrollmentDatePickerOnApply = (event, picker) => {
      $("#bc-datatable").DataTable().state.clear();
      __filter_applied              = true;
      let pickerStartAndEndDate     = document.getElementById('date-range').value;
      pickerStartAndEndDate         = pickerStartAndEndDate.split('-');
      let startdate                 = pickerStartAndEndDate[0].trim();
      let enddate                   = pickerStartAndEndDate[1].trim();
      this.props.setGlobalState({ startdate,enddate});
    }
    handleCancel = (event, picker) => {
      $("#bc-datatable").DataTable().state.clear();
      __filter_applied              = true;
      let startdate = '';
      let enddate   = '';
      this.props.setGlobalState({ startdate,enddate});  
      window.refreshDateRangePicker = 1;
    };
    handleCallback = (start, end, label) => {
    }
    handleChange = (startdate, enddate) => {
    };
    handleEventCompletion = (event, picker) => {
    }
    convertDateFormat = (string ,dateFormat = false) => {
      const dateOnlyFormat = window.formatAMPM(window.changeDatesFormat(string)).split(" ");
      return dateOnlyFormat[0];
  }
    dateEnrollmentCallbacks = (event, picker) => {
      if (event.type == 'show') {
        this.setState({ enrollDateBlock: true });
      }
      if (event.type == 'hide') {
        this.setState({ enrollDateBlock: false });
      }
    }
    getSearchKeyword = (evt) => {
      this.setState({ 'keyword': evt.target.value });
      $("#searchclear").toggle(Boolean($("#user_keyword").val()));
      if(evt.target.value == "") {
        this.keywordSearch(evt.target.value);
      }
    }
    keywordSearch = (evt) => {
      $("#bc-datatable").DataTable().state.clear();
      __filter_applied      = true;
      var key = $('#user_keyword').val();
      this.props.setGlobalState({ 'searchkey': key });
    }
    clearSearchKeyword = () => {
      this.setState({'keyword':''});
      if(this.props.queryFilter.searchkey != '')
      {
        $("#bc-datatable").DataTable().state.clear();
        __filter_applied      = true;
      }      
      $("#user_keyword").val('');
      this.props.setGlobalState({ 'searchkey': '' });
      $("#bc-datatable").DataTable().state.clear();
      $("#searchclear").toggle(Boolean($("#user_keyword").val()));
    }
    render() {
          var today       = new Date();
          var dd          = String(today.getDate()).padStart(2, '0');
          var mm          = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
          var yyyy        = today.getFullYear();
              today       = mm + '/' + dd + '/' + yyyy;
          let datepickerintial = {
            startDate: today, endDate: today, locale: {
              cancelLabel: 'Clear',
              format: 'MM/DD/YYYY'
            }
          };         
          if (this.props.queryFilter.startdate != false && this.props.queryFilter.enddate != false) {
            datepickerintial = {
              startDate: this.props.queryFilter.startdate, endDate: this.props.queryFilter.enddate, locale: {
                cancelLabel: 'Clear',
                format: 'MM/DD/YYYY'
              }
            };
          }

      return (
        <div className="rTable content-nav-tbl">
          <div className="rTableRow ques-pool-grid">  
          <ProductTypeDropDown />
          <ProductDropDown />
          <div className="rTableCell pos-relative">
            <div className="pos-rel date-calendar">
              <label>Date</label>  
              <span className="form-control" id="date-range-span">{this.props.queryFilter.startdate != false?`${this.convertDateFormat(this.props.queryFilter.startdate)} - ${this.convertDateFormat(this.props.queryFilter.enddate)}`:`Select Date`}</span>                  
              <DateRangePicker onEvent={this.dateEnrollmentCallbacks}  onApply={this.enrollmentDatePickerOnApply}   initialSettings={datepickerintial}  onCancel={this.handleCancel}>
                <input type="text" name="daterange" id="date-range" className="form-control h-100 " autoComplete="off" readOnly="readonly" placeholder="Select Date"  />
              </DateRangePicker>
            </div>
          </div>
          <div className="rTableCell search-box">
            <div className="advanced-search">
              <div className="d-flex align-center p0 advanced-search-toggle">
                <div className="input-group d-flex align-center">
                  <input onInput={this.getSearchKeyword} onKeyPress={event => { if (event.key === 'Enter' && event.target.value != '') { this.keywordSearch() } }} type="text" className="form-control srch_txt" id="user_keyword" placeholder="Search" value={this.state.keyword ? this.state.keyword : ''} />
                  <span onClick={() => this.clearSearchKeyword()} id="searchclear" style={{"display": "none"}}>×</span>
                  <a className="input-group-addon" id="basic-addon2" onClick={() => this.keywordSearch()}>
                    <i className="icon icon-search"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="rTableCell">
            <div className="ssave-btn"><button type="button" className="btn theme-blue-btn1" data-toggle="modal" data-target="#course_profile_field_modal" onClick={() => window.exportEnquiryReport()}>Export</button>
            </div>
          </div>
        </div>
      </div>
      )
    }
  }
  export default WithSystem(FilterBlock);